import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const webOrderService = {
  // Get all e-commerce orders with filters and pagination
  getAllWebOrders: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      // Add filter parameters
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
          params.append(key, filters[key]);
        }
      });

      const response = await axios.get(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDERS}?${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get e-commerce order by ID
  getWebOrderById: async (orderId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDER_BY_ID(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update e-commerce order
  updateWebOrder: async (orderId, orderData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDER_EDIT(orderId)}`, orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update e-commerce order status
  updateWebOrderStatus: async (orderId, status) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDER_STATUS(orderId)}`, {
        status: status
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Assign driver to e-commerce order
  assignDriver: async (orderId, driverId) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDER_ASSIGN_DRIVER(orderId)}`, {
        assigned_driver_id: driverId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Assign cashier to e-commerce order
  assignCashier: async (orderId, cashierId) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ECOMMERCE_ORDER_ASSIGN_CASHIER(orderId)}`, {
        assigned_cashier_id: cashierId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default webOrderService;